import { useMemo, useEffect, useState, useRef } from 'react'
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import Select from 'react-select';
import { useARVisitorQuery, useToggleSlotStatusMutation } from '../../../../redux/services/SPL';
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import TableTabs from '../../../../Components/common/TableGrid/TableTabs';
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import { onTabChange, clearSelectedRowsData } from '../../../../redux/features/table/tableSlice';
import { useSelector, useDispatch } from 'react-redux';
import pen from "../../../../assets/images/pen.png";
import info from "../../../../assets/images/info.png";
import TableGrid from "../../../../Components/common/TableGrid";
import { applyOffsetToDateTime, CallApi, getTodayDateTime, Logout } from '../../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import { withRFSToken } from '../../../../Services/axios';
import phonePrefixes from '../../../../Utils/phonePrefixes.json';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import ConfModal from '../../../../Components/common/ConfModal';

const SubVisitor = () => {
  const isMounted = useRef(false);
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const [formData, setFormData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});
  const [modalPos, setModalPos] = useState('');
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const sigPadRef = useRef(null);
   const [searchText, setSearchText] = useState("");
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addVisitorModal, setAddVisitorModal] = useState(false)
  const [linkModal, setLinkModal] = useState(false);
  const [dialCode, setDialCode] = useState();
  const [signatureMode, setSignatureMode] = useState("draw");
  const [typedSignature, setTypedSignature] = useState("");
  const [dvLink, setDvLink] = useState('');
  const [originalLink, setOriginalLink] = useState('');
  const [bothAccess, setBothAccess] = useState(false);
  const [disLoading, setDisLoading] = useState(false);
  const [visitorForm, setVisitorForm] = useState({
    visitor_name: "",
    surname: "",
    company_name: "",
    license: "",
    person_to_meet: "",
    arrived_with_car: "",
    status: "1",
  });
  const [editModal, setEditModal] = useState(false);
  const [dateTimeValue, setDateTimeValue] = useState(""); 
  const saveDateTime = async () => {
      try {
         setDisLoading(true);
          const token = "Bearer " + localStorage.DVR;
          const payload = {
              id: selectedRow.id,
              type: "Visitor",
          };
          if (selectedField === "checkin_date") {
              payload.checkin_date = formatDateTime(dateTimeValue);
          } else {
              payload.checkout_date = formatDateTime(dateTimeValue);
          }
          const res = await withRFSToken.post('vehicle-management/set-checkout-in-time', payload);
          if(res?.data?.response_code === 200){
          refetch();
          setEditModal(false);
          toast.success("Updated Successfully")
        } else{
          toast.error(res?.data?.response_msg || "Error Saving")
        }
        setDisLoading(false);
      } catch (error) {
          // console.error("Save Failed:", error.response?.data || error.message);
          toast.error("Failed to update. Please try again.");
          setDisLoading(false);
      }
  };
  const fetchSettings = async () => {
      try {
        const res = await withRFSToken.get('get-authorize-user');
        const innerData = res?.data?.response_data;
        const trData = innerData.map(dta => ({ id: dta.value, name: dta.label }))
        setUserList(innerData || [])
      } catch (error) {
        console.error('Error fetching settings:', error);
        // toast.error('Failed to load settings');
      }
    };
  const formatDateTime = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};

    if (!entries.length) return params;

    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });

    params.filterscount = entries.length;

    return params;
  };
  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      // type: "security",
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);
  const { data: myData, isFetching, refetch } = useARVisitorQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
    pollingInterval: 900000,
  });
 
  const resetVisitorForm = () => {
    setVisitorForm({
      visitor_name: "",
      surname: "",
      company_name: "",
      license: "",
      person_to_meet: "",
      arrived_with_car: "",
      status: "1",
    });
    setDialCode("");
    setSignatureMode("draw");
    setTypedSignature("");
    if (sigPadRef.current)
      sigPadRef.current.clear();
  };
  const phoneOptions = (phonePrefixes).map(p => ({
    value: p.dialCode,
    label: `${p.dialCode} - ${p.isoCode}`,
    isoCode: p.isoCode
  }))
  const openModal = async () => {

    try {
      const res = await withRFSToken.post('vehicle-management/generate-link', { type: 'Visitor' });
      if (res.data.response_code === 200) {
        const innerData = res?.data?.response_data;
        setDvLink(innerData?.link)
        setOriginalLink(innerData?.link)
        setBothAccess(false)
        setLinkModal(true);
      } else {
        toast.error(res.data.response_msg)
      }

    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  }
  const closeConfirm = () => {
    setLinkModal(false);
  }


  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      inputRef.current.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(inputRef.current.value);
    }
  };

  const confModalClose = () => {
    setModalConf(false);
  }
  const openVisitorModal = () => {
    setAddVisitorModal(true)
  }

  const closeVisitorConfirm = () => {
    setAddVisitorModal(false);
    resetVisitorForm();
  }

  const handleVisitorChange = (e) => {
    const { name, value } = e.target;
    setVisitorForm((prev) => ({ ...prev, [name]: value }));
  };

  const visitorFields = [
    { label: 'Company', type: 'text', name: 'company_name', ph: 'Company name' },
    { label: 'Visitor Name', type: 'text', name: 'visitor_name', ph: 'Visitor name' },
    // { label: 'Phone No.', type: 'tel', name: 'number', ph: 'Phone No.' },
  ];

  const validateVisitorForm = () => {
    if (!visitorForm.visitor_name?.trim()) {
      toast.error("Visitor Name is required");
      return false;
    }
    if (!visitorForm.company_name?.trim()) {
      toast.error("Company Name is required");
      return false;
    }
    if (!visitorForm.arrived_with_car) {
      toast.error("Please select if arrived by car");
      return false;
    }
    if (visitorForm.arrived_with_car === "Yes" && !visitorForm.license?.trim()) {
      toast.error("License Plate No. is required");
      return false;
    }
    return true;
  };

  const handleVisitorSubmit = async () => {
    if (!validateVisitorForm()) return;
    try {
      setDisLoading(true);
      const payload = {
        ...visitorForm
      };
      const res = await withRFSToken.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-visitor`, payload);
      if (res.data?.response_code === 200) {
        const msg = res.data?.response_msg || "Driver saved successfully!";
        toast.success(msg);
        setAddVisitorModal(false);
        resetVisitorForm();
        refetch();
      } else {
        const msg = res.data?.response_msg || "Error saving visitor";
        toast.error(msg);
        // console.warn("Visitor save business error:", res.data);
      }
    } catch (err) {
      console.error("Visitor save error:", err.response?.data || err.message);
      toast.error("Error saving visitor");
    } finally {
      setLoading(false);
      setDisLoading(false);
      setAddVisitorModal(false);
    }
  };

  const filtersConfig = [
    {
      type: "button",
      text: "Add Visitor",
      click: openVisitorModal,
      icon: 'plus',
      class: 'create_btn'

    },
    // {
    //   type: "button",
    //   text: "Generate Link",
    //   click: openModal,
    //   class: 'create_btn'

    // },
    {
      type: "input",
      field: "company_name",
      placeholder: "Company Name",
    },];
  const tabsConfig = [
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];
  const handleModalConf = () => {
    setModalConf(true)
  }
  const handleModalClose = () => {
    setShowModal(false);
  }
  const handleSave = (pos) => {

    let payload = {};
    if (modalPos === 'A') {
      payload = { ...formData, gate_in: getTodayDateTime(), }
    } else {
      if (pos === 'E') {
        payload = { gate_in: formData.gate_in.split('T')[0] + ' ' + formData.gate_in.split('T')[1] }
      } else {
        payload = { gate_in: '' }
      }
    }
    CallApi({
      endPoint: `trip-management/update-slot/${formData.id}`,
      method: 'patch',
      payload: payload,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          toast.success(res.data.response_msg || "Saved successfully");
          handleModalClose();
          if (pos === 'C') {
            setModalConf(false)
          }
          refetch()
        } else {
          toast.error(res.data.response_msg || "Error")
        }
      },
      onError: (msg) => toast.error(msg)
    });

  }
  const handleMoveToActArc = () => {
      if (!selectedRows?.length) {
        toast.error('Please select row first');
        return;
      }
      const isActiveTab = tab?.value === 'A';
      setConfData({
        header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
        subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
        primaryBtn: 'Confirm',
        secondaryBtn: 'Cancel',
        modalConf: tabChangeConf,
      });
      setModalConf(true);
    };
    const tabChangeConf = async () => {
      if (!selectedRows?.length) {
        toast.error('No rows selected');
        return;
      }
      const isActiveTab = tab?.value === 'A';
      const payload = {
        tab: 'Visitor',
        id: selectedRows.map(row => row.id),
        status: isActiveTab ? 0 : 1, 
      };
      try {
        const res = await withRFSToken.post(
          'vehicle-management/update-activity-status',
          payload
        );
        if (res.data.response_code === 200) {
          setModalConf(false);
          refetch();
          dispatch(clearSelectedRowsData());
        } else {
          toast.error(res.data.response_msg);
        }
      } catch (error) {
        console.error('Error updating status:', error);
        toast.error('Something went wrong');
      }
    };
  const columns = [
    { label: "First Name", field: "first_name", enableSearch: false, cls: 'tw-12' },
    { label: "Company Name", field: "company_name", enableSearch: false, cls: 'tw-12' },
    { label: "Car", field: "arrived_with_car", enableSearch: false, cls: 'tw-6' },
    { label: "License Plate No", field: "license", enableSearch: false, cls: 'tw-10' },
    { label: "Person to Meet", field: "person_to_meet", enableSearch: false, cls: 'tw-12' },
    { label: "Date Time In", field: "created_at", enableSearch: false, cls: 'tw-10',
      renderCell: (row) => {
        const formatted = applyOffsetToDateTime(row.created_at, "L");
        return (
          <div>
            {formatted}
          </div>
        );
      }
    },
     { label: "Date Time Out", field: "checkout_date", enableSearch: false, cls: 'tw-11',
      renderCell: (row) => {
        const handleClick = () => {
          if (tab?.value !== 'A') return;
          setSelectedField("checkout_date");
          setSelectedRow(row);
          if (row?.checkout_date) {
            setDateTimeValue(row.checkout_date);
          } else {
            setDateTimeValue(getTodayDateTime());
          }
          setEditModal(true);
        };
        if (tab?.value === 'A') {
          return row.checkout_date ? (
            <span>
              {row.checkout_date}
              <Editicon
                src={pen}
                onClick={handleClick}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            </span>
          ) : (
            <button className="edit_btn" onClick={handleClick}>
              <Editicon /> Set
            </button>
          );
        } else {
          if (!row.checkout_date) return <span>-</span>;
          const date = new Date(row.checkout_date);
          const formatted = date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          });
          return <span>{formatted}</span>;
        }
      }
    },
    {
      label: "Signature", field: "signature_text", enableSearch: false,
      renderCell: () => (
        <img className="signature-info-icon" src={info}  onClick={() => setShowModal(true)} style={{ cursor: "pointer" }}/>
      )
    }
  ];
  const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => {
        let timeslot = "";
        if (item?.slot_start_time && item?.slot_end_time) {
          const [, startTimeFull] = item.slot_start_time.split(" ");
          const [, endTimeFull] = item.slot_end_time.split(" ");
          const startTime = startTimeFull.slice(0, 5);
          const endTime = endTimeFull.slice(0, 5);
          timeslot = `${startTime} - ${endTime}`;
        }
        return {
          ...item,
          planned_date_time: item.planned_date_time
            ? item.planned_date_time.slice(0, 16)
            : "",
          timeslot,
        };
      }) || []
    );
  }, [myData]);
  useEffect(() => {
    dispatch(onTabChange({ key: 'tab', value: "A" }));
    if (isMounted.current) return;
    fetchSettings();
    isMounted.current = true;
  }, []);


  const bulkActions = tab?.value === "A"
  ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
  : tab?.value === "R"
    ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
    : [];

  const handleOnSelect = async (item) => {
    setVisitorForm((prev) => ({ ...prev, 'person_to_meet': item.name, 'appointment_with': item.id }));
  }

  const activateLink = () => {
    const url = inputRef.current.value;
    const logoutUrl = localStorage.getItem('LogOut');

    if (url) {
      window.open(
        url,
        '_blank', 
        'noopener,noreferrer,width=1000,height=800'
      );
    }
    Logout()
    // localStorage.clear();
    // window.location.replace(logoutUrl);
  };
  const filterPhoneOption = (candidate, rawInput) => {
    const input = (rawInput || '').trim();
    if (!input) return true;
    const digits = input.replace(/\D/g, '');
    const label = candidate.label.toLowerCase();
    const iso = (candidate.data?.isoCode || '').toLowerCase();
    if (digits) {
      const optionDigits = String(candidate.value).replace(/\D/g, '');
      return optionDigits.includes(digits);
    }
    return iso.includes(input.toLowerCase()) || label.includes(input.toLowerCase());
  };

      const [selectedField, setSelectedField] = useState(null);
      const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
     {disLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
     {modalConf &&
          <ConfModal
              header={confData.header}
              subHeader={confData.subHeader}
              modalConf={confData.modalConf}
              closeModal={confModalClose}
              primaryBtn={confData.primaryBtn}
              secondaryBtn={confData.secondaryBtn}
          />
      }
      <div className="main-content">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={transformedRows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
      </div>
      <Modal show={linkModal} onHide={closeConfirm} className="modal_bgw primary_modal" centered>
        <Modal.Header closeButton><Modal.Title>Generate Link</Modal.Title></Modal.Header>
        <Modal.Body>
          {dvLink && <><Form.Label>Link</Form.Label>
            <div className='d-flex gap-2'>
              <Form.Control
                type="text"
                ref={inputRef}
                name="link"
                value={dvLink || ''}
                readOnly
              />
              <Button onClick={handleCopy}>Copy</Button>
            </div></>}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeConfirm}> Cancel </Button>
            <Button variant="primary" onClick={activateLink}> Activate </Button>
            {/* <Button variant="primary" onClick={handleRegenerateConfirm}>  {dvLink ? "Regenerate" : "Generate"} </Button> */}
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={addVisitorModal} onHide={closeVisitorConfirm} className="modal_bgw primary_modal change_type" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Visitor Registration
            <p>Create a new visitor record</p>

          </Modal.Title>
          </Modal.Header>
        <Modal.Body>
          {/* <p className='visitor_text'>Please share your details to complete visitor registration</p> */}
          <div>
            <Form>
              {visitorFields.map((frm, index) => (
                <Form.Group className="mb-2" key={`v_${index}`}>
                  <Form.Label>{frm.label} <span className="text-danger">*</span></Form.Label>
                  {frm.name === 'number' ? (
                    <InputGroup>
                      <div className='phone_code' style={{ width: '40%' }}>
                        <Select
                          options={phoneOptions}
                          filterOption={filterPhoneOption}
                          placeholder="Code"
                          value={phoneOptions.find(o => o.value === dialCode) || null}
                          onChange={(opt) => {
                            const newCode = opt ? opt.value : '';
                            setDialCode(newCode);
                            const local = visitorForm.number ? (visitorForm.number.split('-')[1] || '') : '';
                            setVisitorForm(prev => ({ ...prev, number: newCode ? `${newCode}-${local}` : local }));
                          }}
                          isClearable
                        />
                      </div>
                      <Form.Control
                        type="tel"
                        name={frm.name}
                        value={visitorForm.number ? (visitorForm.number.split('-')[1] || '') : ''}
                        onChange={(e) => {
                          const local = e.target.value;
                          const code = dialCode || '';
                          setVisitorForm(prev => ({ ...prev, number: code ? `${code}-${local}` : local }));
                        }}
                        placeholder={frm.ph}
                        inputMode="numeric"
                        style={{ borderRadius: '8px' }}
                      />
                    </InputGroup>
                  ) : (
                    <Form.Control
                      type={frm.type}
                      name={frm.name}
                      value={visitorForm[frm.name]}
                      onChange={handleVisitorChange}
                      placeholder={frm.ph}
                      style={{ borderRadius: '8px' }}
                    />
                  )}
                </Form.Group>
              ))}
              <Form.Group className="mb-2">
                <Form.Label>Appointment With</Form.Label>
                {/* <Select
                          options={userList}
                          onChange={(selected) => {
                            const updatedData = { ...visitorForm, person_to_meet: selected.value };
                            setVisitorForm(updatedData);
                          }}
                          placeholder="Select"
                          className=''
                          filterOption={customFilter}
                          isClearable
                          menuIsOpen={undefined}
                          name="person_to_meet"
                          value={userList.find(option => option.value === visitorForm.person_to_meet)}
                        /> */}
                <div className={searchText.length < 3 ? "hide-no-results" : ""}>
                  <style>
                    {`
                              .hide-no-results .sc-gEvEer.ffXrxx {
                                display: none !important;
                              }
                            `}
                  </style>
                  <ReactSearchAutocomplete
                    items={userList}
                    onSelect={handleOnSelect}
                    onSearch={(string) => {
                      setSearchText(string);
                    }}
                    autoFocus
                    placeholder="Appointment With"
                    fuseOptions={{
                      shouldSort: true,
                      threshold: 0.0, // exact match required at start
                      location: 0,    // start of string
                      distance: 0,
                      minMatchCharLength: 3,
                      keys: ["name"]
                    }}
                    styling={{
                      resultsContainer: {
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        zIndex: 9999
                      },
                      resultItem: {
                        padding: "10px",
                        cursor: "pointer"
                      },
                      resultItemHover: {
                        backgroundColor: "#f0f0f0"
                      }
                    }}
                  />
                </div>
                {/* <Form.Control
                        type="text"
                        name="person_to_meet"
                        value={visitorForm.person_to_meet}
                        onChange={handleVisitorChange}
                        placeholder="Appointment with"
                      /> */}
              </Form.Group>
              {/* <Form.Group className="mb-3">
                        <Form.Label>Visitor Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="visitor_name"
                          value={visitorForm.visitor_name}
                          onChange={handleVisitorChange}
                          placeholder="Visitor name"
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          type="text"
                          name="company_name"
                          value={visitorForm.company_name}
                          onChange={handleVisitorChange}
                          placeholder="Company name"
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>License Plate No.</Form.Label>
                        <Form.Control
                          type="text"
                          name="license"
                          value={visitorForm.license}
                          onChange={handleVisitorChange}
                          placeholder="License plate no."
                        />
                      </Form.Group> */}
              <Form.Group className="sl_status">
                <Form.Label>Arrived by Car <span className="text-danger">*</span></Form.Label>
                <div className='radio-card-group'>
                  <Form.Check
                    inline
                    label="Yes"
                    type="radio"
                    id="arrived_yes"
                    value="Yes"
                    name="arrived_with_car"
                    checked={visitorForm.arrived_with_car === "Yes"}
                    onChange={(e) =>
                      setVisitorForm((prev) => ({
                        ...prev,
                        arrived_with_car: e.target.value,
                      }))
                    }
                  />
                  <Form.Check
                    inline
                    label="No"
                    type="radio"
                    id="arrived_no"
                    value="No"
                    name="arrived_with_car"
                    checked={visitorForm.arrived_with_car === "No"}
                    onChange={(e) =>
                      setVisitorForm((prev) => ({
                        ...prev,
                        arrived_with_car: e.target.value,
                        license: "", // clear license if "No"
                      }))
                    }
                  />
                </div>
              </Form.Group>



              {visitorForm.arrived_with_car === "Yes" && (
                <Form.Group className="mb-3">
                  <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="license"
                    value={visitorForm.license}
                    onChange={handleVisitorChange}
                    placeholder="License plate no."
                  />
                </Form.Group>
              )}

              {/* Signature */}
              {/* <Form.Group className="mb-3">
                        <Form.Label>Signature</Form.Label>
                        {signatureMode === "draw" ? (
                          <div style={{ border: "1px solid #ddd", borderRadius: "8px", background: "#f9f9f9", }}>
      
                            <SignatureCanvas ref={sigPadRef} penColor="black" canvasProps={{ width: 420, height: 150, className: "sigCanvas", }} />
                            <Button size="sm" variant="light" className="mt-2" onClick={() => sigPadRef.current.clear()}>
                              <FontAwesomeIcon icon={faEraser} />
                            </Button>
                          </div>
                        ) : (
                          <Form.Control
                            type="text"
                            placeholder="Type your signature"
                            className="type_sign"
                            value={typedSignature}
                            onChange={(e) =>
                              setTypedSignature(e.target.value)}
                          />
                        )}
                        <Row className="mt-3">
                          <Col>
                            <Button
                              variant={
                                signatureMode === "draw"
                                  ? "secondary"
                                  : "outline-secondary"
                              }
                              size="sm"
                              className="w-100 loading_unloading_btn"
                              onClick={() => setSignatureMode("draw")}
                            >
                              Draw Signature
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              variant={
                                signatureMode === "type"
                                  ? "secondary"
                                  : "outline-secondary"
                              }
                              size="sm"
                              className="w-100 loading_unloading_btn"
                              onClick={() => setSignatureMode("type")}
                            >
                              Typing Signature
                            </Button>
                          </Col>
                        </Row>
                      </Form.Group> */}
              {/* Buttons */}

            </Form>
          </div>
        </Modal.Body>
         <Modal.Footer>
                  <Button variant="primary" onClick={handleVisitorSubmit}>
                      Submit
                  </Button>
              </Modal.Footer>
        
      </Modal>
      <Modal show={editModal} onHide={() => setEditModal(false)} centered className="modal_bgw primary_modal">
        <Modal.Header closeButton>
            {/* <Modal.Title>Edit {selectedField === "checkin_date" ? "Date Time In" : "Date Time Out"}</Modal.Title> */}
            <Modal.Title>Edit Date Time Out
              <p>Set or update checkout date and time</p>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form.Group>
                <Form.Label>Select Date & Time</Form.Label>
                <Form.Control
                    type="datetime-local"
                    value={dateTimeValue}
                    onChange={(e) => setDateTimeValue(e.target.value)}
                />
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={saveDateTime}>
                Save
            </Button>
        </Modal.Footer>
        </Modal>
      <Modal className="modal_bgw primary_modal" show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Signature Info
              <p>See signature details</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
              <p className='mb-3'>To View This Signature. <br /> Please Contact Cargohub <b>Support Team</b></p>
          </Modal.Body>
      </Modal>
    </>
  )
}

export default SubVisitor